import script from "./VefatScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./VefatScreen.vue?vue&type=script&setup=true&lang=js"

import "./VefatScreen.vue?vue&type=style&index=0&id=725f1f90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725f1f90"]])

export default __exports__